import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "billing-purchase"
  static values = {
    accountId: String,
    offeringIdentifier: String,
    fallbackUrl: String,
    synchronizationUrl: String
  }

  purchase(event) {
    event.preventDefault()

    this.send("purchase", {
      account_id: this.accountIdValue,
      offering_identifier: this.hasOfferingIdentifierValue ? this.offeringIdentifierValue : null
    }, (message) => {
      if (message.data?.completed) {
        this.synchronizeAndReload()
      } else if (message.data?.error && this.hasFallbackUrlValue) {
        window.location.assign(this.fallbackUrlValue)
      }
    })
  }

  async synchronizeAndReload() {
    if (this.hasSynchronizationUrlValue) {
      const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

      try {
        await fetch(this.synchronizationUrlValue, {
          method: "POST",
          credentials: "same-origin",
          headers: { "X-CSRF-Token": csrfToken, "Accept": "application/json" }
        })
      } catch (_error) {
        // The RevenueCat webhook remains the durable retry path.
      }
    }

    window.Turbo.visit(window.location.href, { action: "replace" })
  }
}
